import {Colors} from '../../styles/Colors';
import {Cancel, Edit} from '@material-ui/icons';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {makeStyles} from '@material-ui/core/styles';
import Button from '../Button/Button';
import IconButton from '../Button/IconButton';
import PermissionProvider from '../PermissionProvider/PermissionProvider';
import {Permission} from '../../store/types/Permission';

const useStyles = makeStyles(() => ({
    root: {
        textTransform: 'uppercase',
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
    },

    iconModeRoot:{
        textTransform: 'uppercase',
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
    },
    editButton: {
        width: 'unset!important',
        minWidth: 'unset',
    },
}));

type ActionsButtonsProps = {
    release?: boolean;
    releaseClick?: () => void;
    editClick?: () => void;
    iconMode?: boolean
};

const ActionsButtons: React.FC<ActionsButtonsProps> = (
    {
        releaseClick,
        release = true,
        editClick,
        iconMode
    }) => {
    const {t} = useTranslation();
    const classes = useStyles();
    return (
        <span className={!iconMode ? classes.root : classes.iconModeRoot}>
            <PermissionProvider
                permission={Permission.Inventory.Devices.DeviceDetails.EditPort.value}
            >
                {!iconMode ? (<Button
                    onClick={editClick}
                    dataTestId="edit-list-item-button"
                    dataQa="edit-list-item-button"
                    icon={<Edit htmlColor={Colors.Gray5}/>}
                    ternary
                    className={classes.editButton}

                >
                    {t('common:edit')}
                </Button>) : (<IconButton
                    dataTestId="icon-edit-list-item-button"
                    dataQa="icon-edit-list-item-button"
                    icon={<Edit htmlColor={Colors.Gray5}/>}
                    tooltipText={t('common:edit')}
                    ternary
                    className={classes.editButton}
                    onClick={editClick}
                />)
                }
            </PermissionProvider>
            {release && (
                <PermissionProvider
                    permission={Permission.Inventory.Devices.DeviceDetails.ReleasePort.value}
                >
                    {!iconMode ? (<Button
                        dataTestId="release-list-item-button"
                        dataQa="release-list-item-button"
                        onClick={releaseClick}
                        ternary
                        icon={<Cancel htmlColor={Colors.Gray5}/>}
                    >
                        {t('common:release')}
                    </Button>) : (
                        <IconButton
                            dataTestId="icon-release-list-item-button"
                            dataQa="icon-release-list-item-button"
                            icon={<Cancel htmlColor={Colors.Gray5}/>}
                            tooltipText={t('common:release')}
                            className={classes.editButton}
                            onClick={releaseClick}
                            ternary
                        />
                    )}
                </PermissionProvider>
            )}
            {
                !release && iconMode && <div style={{width: 32}}></div>
            }
        </span>
    );
};

export default ActionsButtons;
